import { BullModule } from '@nestjs/bullmq';
import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { GastosModule } from '../gastos.module';
import { GastosImportadorController } from './gastos-importador.controller';
import { GastosImportadorProcessor } from './gastos-importador.processor';
import { GASTOS_IMPORT_QUEUE, GastosImportadorService } from './gastos-importador.service';
import { ProveedorResolverService } from './services/proveedor-resolver.service';

@Module({
  imports: [PrismaModule, GastosModule, BullModule.registerQueue({ name: GASTOS_IMPORT_QUEUE })],
  controllers: [GastosImportadorController],
  providers: [GastosImportadorService, GastosImportadorProcessor, ProveedorResolverService],
})
export class GastosImportadorModule {}
